import actionTypes from "../../actions/actionTypes";

const _initState = {
  isLoading: false,
  data: [],
  total: 0,
};

const listVyjadrenie = (state = _initState, action) => {
  switch (action.type) {
    case actionTypes.GET_LIST_VYJADRENIE_REQUEST:
      return { ...state, isLoading: true };

    case actionTypes.GET_LIST_VYJADRENIE_SUCCESS:
      const { Items, TotalRecords } = action.res.Data;
      return { ...state, isLoading: false, data: Items, total: TotalRecords };

    case actionTypes.GET_LIST_VYJADRENIE_FAILURE:
      return _initState;

    default:
      return state;
  }
};

export default listVyjadrenie;
